import { TRACING_URL_WORD } from '@shared/model/constants/contentTemplate'

export const getTracingUrlId = (id: number) => `${TRACING_URL_WORD}${id}`

export default getTracingUrlId
